export default "__VITE_ASSET__CBVqy$Fi__"